<template>
  <div>
    <a-table
      :loading="loading"
      :pagination="false"
      :columns="columns"
      :data-source="upfileList"
      :row-key="(record) => record.mongoFileId"
    >
      <!-- 序号 -->
      <div slot="number" slot-scope="text, record, index">
        {{ index + 1 }}
      </div>
      <!-- 开具材料时间 -->
      <div slot="inputTime" slot-scope="text, record">
        <a-date-picker
          :disabled="disabled"
          :valueFormat="dayFormat"
          class="w200"
          v-model="record.inputTime"
          @change="handleChange"
        />
      </div>
      <!-- 开具材料名称 -->
      <div slot="materialScienceName" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.materialScienceName"
          @blur="handleChange"
        />
      </div>
      <!-- 办理人 -->
      <div slot="handleName" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.handleName"
          @blur="handleChange"
        />
      </div>
      <!-- 备注 -->
      <div slot="description" slot-scope="text, record">
        <a-input
          :disabled="disabled"
          allowClear
          class="w100"
          placeholder="请输入"
          v-model="record.description"
          @blur="handleChange"
        />
      </div>
      <!-- <div slot="operator">
        {{ $store.state.app.userInfo.fullName }}
      </div> -->
      <div slot="action" slot-scope="text, record, index">
        <a-button type="link" class="btn-link" @click="goDetial(record, index)">
          查看
        </a-button>
        <a-divider type="vertical" v-if="!disabled" />
        <a-button
          v-if="!disabled"
          type="link"
          class="btn-link"
          @click="removeFiles(record.mongoFileId, record)"
        >
          删除
        </a-button>
      </div>
    </a-table>
    <div class="accessory-btn" v-if="!disabled">
      <a-upload
        name="file"
        :multiple="false"
        :headers="headers"
        action="#"
        :fileList="fileList"
        @change="uploadFiles"
        :showUploadList="false"
        :beforeUpload="beforeUpload"
      >
        <a-button @click="fileList = []"
          ><a-icon type="upload" />上传文件
        </a-button>
      </a-upload>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    key: 'number',
    scopedSlots: { customRender: 'number' },
    title: '序号',
    align: 'left',
    width: 120
  },
  {
    key: 'inputTime',
    scopedSlots: { customRender: 'inputTime' },
    title: '开具材料时间',
    align: 'left'
    // width: 100
  },
  {
    key: 'materialScienceName',
    scopedSlots: { customRender: 'materialScienceName' },
    title: '开具材料名称',
    align: 'left'
    // width: 100
  },

  {
    key: 'handleName',
    scopedSlots: { customRender: 'handleName' },
    title: '办理人',
    align: 'left'
    // width: 100
  },
  {
    key: 'description',
    scopedSlots: { customRender: 'description' },
    title: '备注',
    align: 'left'
    // width: 100
  },
  // {
  //   key: 'add',
  //   scopedSlots: { customRender: 'add' },
  //   title: '附件',
  //   align: 'left',
  //   width: 100
  // },

  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import { kkFileUrl, fileUrlHOST } from '@/http/config'
import { saveFile, getFile, invoiceDistinct } from '@/http/url'
import { getSuffix, formatDate } from '@/assets/js/auth'
import pigImg from '@/components/pigImg.vue'
export default {
  components: {
    pigImg
  },
  props: ['disabled', 'updateList', 'file', 'detailsId'],
  model: {
    event: 'input',
    prop: 'updateList'
  },
  data() {
    return {
      columns,
      data: [],
      headers: {
        Authentication: localStorage.getItem('token')
      },
      invoiceUrl: '',
      loading: false,
      isImg: false,
      dayFormat: 'YYYY.MM.DD',
      fileList: [],
      upfileList: [], //上传成功的附件列表
      record: {},
      targetIndex: null, // 当前操作行index
      editForm: {}
    }
  },
  watch: {
    file(val) {
      if (val) {
        this.upfileList = this.file
      }
    },
    upfileList: {
      handler(val) {
        this.emitData()
      },
      deep: true
    }
  },
  mounted() {
    if (this.file) {
      this.upfileList = this.file
    }
  },
  methods: {
    formatDateIt(data) {
      // 时间格式化
      return formatDate(data)
    },
    goDetial(item, index) {
      // 查看
      if (item.fileformat == 'bpmn') {
        this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
      } else {
        let Base64 = require('js-base64').Base64
        window.open(
          item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
        )
      }
    },
    // 上传附件
    uploadFiles(file) {
      if (file.file.size > 10485760) {
        // 大于10M 拦截
        this.$message.error('上传文件不得大于10M！')
      } else {
        this.saveFileFn(file.file)
      }
    },
    // 移除
    removeFiles(id, record) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          // 新增删除
          let index = this.upfileList.findIndex(
            (item) => item.mongoFileId == id
          )
          this.upfileList.splice(index, 1)
          this.$message.success('删除成功')
          if (this.detailsId) {
            this.handleChange()
          }
        }
      })
    },
    beforeUpload() {
      return false
    },
    saveFileFn(file) {
      const formDataChildren = new FormData()
      formDataChildren.append('file', file)
      this.$message.loading('上传中···', 0)
      saveFile(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.$message.success('上传成功')
          let fileData = {}
          let SuffixArray = getSuffix(file.name)
          fileData.filename = SuffixArray[1]
          fileData.fileformat = SuffixArray[0]
          fileData.mongoFileId = res.data.data
          fileData.kkFileUrl = kkFileUrl
          fileData.fileUrl =
            fileUrlHOST +
            'mongo/kkFile?fileId=' +
            fileData.mongoFileId +
            '&fullfilename=' +
            SuffixArray[2]

          fileData.createTime = this.formatDateIt(new Date())
          this.upfileList.push(fileData)
          this.emitData()
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    emitData() {
      this.$emit('input', this.upfileList)
    },
    handleChange() {
      this.$emit('change', this.upfileList)
    }
  }
}
</script>
<style scoped lang="scss">
.accessory-btn {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img_btm {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .imgBtn {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/TheDead/components/materials-table.vue